import { render, staticRenderFns } from "./Element.vue?vue&type=template&id=bd431094"
import script from "./Element.vue?vue&type=script&lang=js"
export * from "./Element.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_css-loader@6.11.0_webpack@5.107.2_postcss@8_304b4a1ebea3bd82ec282759e0696211/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports